const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方字符串内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_string.html
 * @author Caesar Liu
 * @date 2020-11-20 15:03
 */
module.exports = [
  buildConfig('boolean', {
    documentation: [
      '将字符串转为布尔值',
      'e.g: ${"true"?boolean}',
      'x必须为"true"或"false"字符串'
    ].join('\n')
  }),
  buildConfig('cap_first', {
    documentation: [
      '将首字母转为大写',
      'e.g: ${"hello"?cap_first} 返回"Hello"'
    ].join('\n')
  }),
  buildConfig('capitalize', {
    documentation: [
      '将所有单词的首字母转为大写',
      'e.g: ${"hello jack"?capitalize}',
      '返回"Hello Jack"'
    ].join('\n')
  }),
  buildConfig('chop_linebreak', {
    documentation: '如果参数值尾部没有换行将自动添加换行'
  }),
  buildConfig('contains', {
    documentation: [
      '判断字符串是否包含字串',
      'e.g: ${"piceous"?contains("ice")}',
      '返回布尔值true'
    ].join('\n')
  }),
  buildConfig('date', {
    documentation: [
      '将字符串转为日期',
      'e.g: ${"25/03/1995"?date("dd/MM/yyyy")}'
    ].join('\n')
  }),
  buildConfig('time', {
    documentation: [
      '将字符串转为时间',
      'e.g: ${"15:05:30"?time("HH:mm:ss")}'
    ].join('\n')
  }),
  buildConfig('datetime', {
    documentation: [
      '将字符串转为日期',
      'e.g: ${"1995-03-25 03:25 PM"?datetime("yyyy-MM-dd hh:mm a")}'
    ].join('\n')
  }),
  buildConfig('ends_with', {
    documentation: [
      '判断字符串是否以另一个字符串结尾',
      'e.g: ${"ahead"?ends_with("head")}',
      '返回布尔值true'
    ].join('\n')
  }),
  buildConfig('ensure_ends_with', {
    documentation: [
      '如果字符串s1不以另一个字符串s2结尾，则返回s1+s2，否则返回s1',
      'e.g 1: ${"foo"?ensure_ends_with("/")}',
      'e.g 2: ${"foo/"?ensure_ends_with("/")}',
      '以上返回结果均为"foo/"'
    ].join('\n')
  }),
  buildConfig('ensure_starts_with', {
    documentation: [
      '如果字符串s1不以另一个字符串s2开头，则返回s2+s1，否则返回s1',
      'e.g 1: ${"foo"?ensure_starts_with("/")}',
      'e.g 2: ${"/foo"?ensure_starts_with("/")}',
      '以上返回结果均为"/foo"'
    ].join('\n')
  }),
  buildConfig('groups', { documentation: '仅作用于内建函数 matches 的结果' }),
  buildConfig('html', { documentation: '字符串按照HTML标记输出' }),
  buildConfig('index_of', {
    documentation: [
      '返回字符串中第一次出现子串时的索引位置',
      'e.g: ${"abcabc"?index_of("bc")} 返回1'
    ].join('\n')
  }),
  buildConfig('keep_after', {
    documentation: [
      '返回字符串中第一次出现子串后的字符串',
      'e.g: ${"abcdefgh"?keep_after("de")}',
      '返回"fgh"'
    ].join('\n')
  }),
  buildConfig('keep_after_last', {
    documentation: [
      '返回字符串中最后一次出现子串后的字符串',
      'e.g: ${"foo.bar.txt"?keep_after_last(".")}',
      '返回"txt"'
    ].join('\n')
  }),
  buildConfig('keep_before', {
    documentation: [
      '返回字符串中第一次出现子串前的字符串',
      'e.g: ${"abcdef"?keep_before("de")}',
      '返回"abc"'
    ].join('\n')
  }),
  buildConfig('keep_before_last', {
    documentation: [
      '返回字符串中第一次出现子串前的字符串',
      'e.g: ${"foo.bar.txt"?keep_before_last(".")}',
      '返回"foo.bar"'
    ].join('\n')
  }),
  buildConfig('last_index_of', {
    documentation: [
      '返回字符串中最后一次出现子串时的索引位置',
      'e.g: ${"abcabc"?last_index_of("ab")}',
      '返回3'
    ].join('\n')
  }),
  buildConfig('left_pad', {
    documentation: [
      '如果字符串不够指定长度，则在前方插入指定字符，默认为空格符',
      '@param1: 指定长度',
      '@param2: 指定字符，默认为空格符',
      'e.g 1: ${""?left_pad(5)} 输出"     "',
      'e.g 2: ${"a"?left_pad(5)} 输出"    a"',
      'e.g 3: ${"ab"?left_pad(5)} 输出"   ab"',
      'e.g 4: ${"ab"?left_pad(5, "-")} 输出"---ab"',
      'e.g 5: ${"abcdef"?left_pad(5, "-")} 输出"abcdef"'
    ].join('\n')
  }),
  buildConfig('length', {
    documentation: [
      '返会字符串中字符的数量',
      'e.g: ${"string"?length}',
      '返回6'
    ].join('\n')
  }),
  buildConfig('lower_case', {
    documentation: [
      '字符串的小写形式',
      'e.g: ${"GrEeN MoUsE"?lower_case}',
      '返回"green mouse"'
    ]
  }),
  buildConfig('matches', {
    documentation: '是否满足正则表达式'
  }),
  buildConfig('replace', {
    documentation: [
      '字符串替换',
      'e.g: ${"abc"?replace("bc", "oe")}',
      '返回"aoe"'
    ].join('\n')
  }),
  buildConfig('right_pad', {
    documentation: [
      '如果字符串不够指定长度，则在后方插入指定字符，默认为空格符',
      '@param1: 指定长度',
      '@param2: 指定字符，默认为空格符',
      'e.g 1: ${""?right_pad(5)} 输出"     "',
      'e.g 2: ${"a"?right_pad(5)} 输出"a    "',
      'e.g 3: ${"ab"?right_pad(5)} 输出"ab   "}',
      'e.g 4: ${"ab"?right_pad(5, "-")} 输出"ab---"}',
      'e.g 5: ${"abcdef"?right_pad(5, "-")} 输出"abcdef"}'
    ].join('\n')
  }),
  buildConfig('remove_beginning', {
    documentation: [
      '从字符串的开头移除指定子串，如果它不以指定子串开头则返回原字符串',
      'e.g 1: ${"abcdef"?remove_beginning("abc")}',
      'e.g 2: ${"foobar"?remove_beginning("abc")}',
      '分别返回"def"和"foobar"'
    ].join('\n')
  }),
  buildConfig('remove_ending', {
    documentation: [
      '从字符串的结尾移除指定子串，如果它不以指定子串结尾则返回原字符串',
      'e.g 1: ${"abcdef"?remove_ending("def")}',
      'e.g 2: ${"foobar"?remove_ending("def")}',
      '分别返回"abc"和"foobar"'
    ].join('\n')
  }),
  buildConfig('rtf', {
    documentation: [
      '将字符串转为富文本（RTF文本）',
      '- \\ 替换为 \\\\',
      '- { 替换为 \\{',
      '- } 替换为 \\}'
    ].join('\n')
  }),
  buildConfig('split', {
    documentation: [
      '将字符串根据字串分割成数组',
      'e.g: ${"a,b,c"?split(",")}',
      '返回["a", "b", "c"]'
    ].join('\n')
  }),
  buildConfig('starts_with', {
    documentation: [
      '判断字符串是否以指定字串开头',
      'e.g: ${"redirect"?starts_with("red")}',
      '返回布尔值true'
    ].join('\n')
  }),
  buildConfig('string', {
    documentation: [
      '将参数转为字符串，当应用于布尔参数时类似三元表达式',
      'e.g 1: ${1?string} 返回"1"',
      'e.g 2: ${true?string("Y", "N")} 返回"Y"'
    ].join('\n')
  }),
  buildConfig('c', {
    documentation: [
      '应用于数字和布尔参数时将参数转为字符串',
      'e.g 1: ${200?c} 返回"200"',
      'e.g 2: ${true?c} 返回"true"'
    ].join('\n')
  }),
  buildConfig('trim', {
    documentation: [
      '去掉字符串的首尾空格',
      'e.g: ${"  green mouse  "?trim}',
      '返回"green mouse"'
    ].join('\n')
  }),
  buildConfig('uncap_first', {
    documentation: [
      '将字符串中的首字母小写',
      'e.g: ${"Green Mouse"?uncap_first}',
      '返回"green Mouse"'
    ].join('\n')
  }),
  buildConfig('upper_case', {
    documentation: [
      '将字符串中转为大写',
      'e.g: ${"Green Mouse"?upper_case}',
      '返回"GREEN MOUSE"'
    ].join('\n')
  }),
  // 执行报错
  // buildConfig('url', {
  //   documentation: [
  //     '将字符串进行URL转译',
  //     'e.g: ${"a/b c"?url}',
  //     '返回"a%2Fb%20c"'
  //   ].join('\n')
  // }),
  // 执行报错
  // buildConfig('url_path', {
  //   documentation: [
  //     '它和 url 内建函数 相同，只是它不转义斜杠 (/)字符。这就是意味着用来转义使用了斜杠(不是反斜杠！)的路径 (比如操作系统或一些内容仓库的路径)，转义之后它们可以插入到URL中。 需要该转义的常用原因是文件夹名称或文件名称可能含有非US-ASCII字母 ("国家" 标准符号)。',
  //     '和 the url 内建函数 相似，希望的URL转义字符 (或者后退，输出编码)必须要在 FreeMarker的配置设置项中设置， 否则内建函数就会报错。或者可以指定字符集，比如 somePath?url_path("utf-8")。',
  //   ].join('\n')
  // }),
  buildConfig('word_list', {
    documentation: [
      '将字符串根据空格符号解析成数组',
      'e.g: ${"   a bcd, .   1-2-3"?word_list}',
      '返回["a", "bcd,", ".", "1-2-3"]'
    ].join('\n')
  }),
  buildConfig('xhtml', {
    documentation: [
      '将字符串转为XHTML格式文本',
      '- < 替换为 &lt;',
      '- > 替换为 &gt;',
      '- & 替换为 &amp;',
      '- " 替换为 &quot',
      '- \' 替换为 &#39;'
    ].join('\n')
  }),
  buildConfig('xml', {
    documentation: [
      '将字符串转为XML格式文本',
      '- < 替换为 &lt;',
      '- > 替换为 &gt;',
      '- & 替换为 &amp;',
      '- " 替换为 &quot',
      '- \' 替换为 &apos;'
    ].join('\n')
  })
]
